import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetInstitutionFormIdentityByIdRequest,
    type GetInstitutionFormIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useInstitutionFormIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetInstitutionFormIdentityByIdResponse,
        GetInstitutionFormIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetInstitutionFormIdentityByIdResponse> =>
            new GetInstitutionFormIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetInstitutionFormIdentityByIdResponse>) =>
                response?.data?.institutionFormIdentity,
            getError: (response?: SWRResponse<GetInstitutionFormIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useInstitutionFormIdentityById;
